import $ from 'jquery'

$(document).on(
  'click',
  '[data-behaviour="toggle-selector-visibility"]',
  (event) => {
    const currentContent = $(event.target).html()
    if (currentContent === $(event.target).data('content-hidden')) {
      $(event.target).html($(event.target).data('content-visible'))
    } else {
      $(event.target).html($(event.target).data('content-hidden'))
    }

    const selector = $(event.target).data('target')
    $(selector).toggle()
  }
)
